document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.daytext')) {
		var dt = new Date().getHours();
		var dayTextElement = document.querySelector('.daytext');

		if (dt >= 6 && dt <= 11) {
			// GOOD MORNING
			dayTextElement.textContent = strl_vars.header_morning;
		} else if (dt >= 12 && dt <= 17) {
			// GOOD AFTERNOON
			dayTextElement.textContent = strl_vars.header_afternoon;
		} else if (dt >= 18 && dt <= 23) {
			// GOOD EVENING
			dayTextElement.textContent = strl_vars.header_evening;
		} else if (dt >= 0 && dt <= 5) {
			// GOOD NIGHT
			dayTextElement.textContent = strl_vars.header_night;
		}
	}
});
